import { render, staticRenderFns } from "./DateLimit.vue?vue&type=template&id=0b071fea"
import script from "./DateLimit.vue?vue&type=script&lang=js"
export * from "./DateLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports